import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import { getProductDefaultInfo } from '../../../../utilities/selectors';
import {
  getZemplinProductDefaultInfo,
  getZemplinCartProductInfo,
  getZemplinTrueCount,
  getElasticCategoryZemplinProductInfo,
  isSpojMatOrPreDrev,
  getPackagesString,
  resolveIsVykurovaciaOrPletiva,
} from '../../selectors';
import { OrderNrInput } from '../../Product/OrderNrInput';
import { StockInfo } from '../../Product/StockInfo';
import { ProductPriceCartTable } from '../../Product/ProductPriceCartTable';
import { TableTd, TableRow } from '../../General/Table';
import {
  FlexCol,
  FlexRowCenterHorizontal,
} from '../../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../../Defaults/Text';
import { IconType, SvgIcon } from '../../General/SvgIcon';
import { CountSetter } from '../../ProductDetail/CountSetter';
import { FormInput } from '../../Form/FormInput';
import { DotDelimeter } from '../../General/DotDelimeter';
import {
  getSymbolFromCurrency,
  formatPriceToString,
  round,
  prop,
} from '../../../../utilities';
import { InfoText, InfoType } from '../../General/InfoText';
import { on } from 'cluster';
import { ModalMobileValue } from './ModalMobileValue';
import { __ } from 'react-i18n';

export interface Props {
  product: any;
  theme: any;
  count: string;
  handleCountChange: any;
  isLoggedIn: any;
  isFromCategory?: boolean;
  isRequest?: boolean;
  noHandlingFee?: boolean;
}

function ModalItemsTabRow({
  product,
  theme,
  count,
  handleCountChange,
  isLoggedIn,
  isFromCategory,
  isRequest,
  noHandlingFee,
}: Props) {
  const [isFocused, setIsFocused] = React.useState(false);

  const { currency } = getProductDefaultInfo(product);
  const {
    unit,
    price,
    priceWithoutVat,
    productPackages,
    unpackingCost,
    unpackingCostWithoutVat,
    onStock,
    priceForUnpacking,
    customerPrices,
    isSpojMat,
    defaultPackageSize,
    wholePackagesOnly,
  } = isFromCategory
    ? getElasticCategoryZemplinProductInfo(product, isLoggedIn)
    : getZemplinProductDefaultInfo(product);

  // Ak mame kd sipozicii defaultnu hodnotu vlekosti balenia, pouzijeme ju
  const step = defaultPackageSize
    ? defaultPackageSize
    : productPackages
    ? productPackages
    : unit === 'Mks'
    ? 0.001
    : 1;

  // count = count > onStock && onStock > 0 ? onStock : count;
  const trueCount = unit === 'Mks' ? +count * 1000 : count;
  const correctPriceForUnpacking = priceForUnpacking ? priceForUnpacking : 5;
  let correctUnpackingCost = isLoggedIn
    ? unpackingCostWithoutVat
    : unpackingCost;
  correctUnpackingCost =
    correctPriceForUnpacking * +trueCount < 10 &&
    productPackages >= 0.026 &&
    productPackages > count &&
    correctUnpackingCost
      ? correctUnpackingCost * +trueCount
      : 0;

  correctUnpackingCost =
    productPackages > onStock && onStock === count ? 0 : correctUnpackingCost;

  const correctPrice = isLoggedIn ? +priceWithoutVat : +price;
  let totalPrice = correctPrice ? +correctPrice * +count : '';
  const correctCustomerPrice = customerPrices
    ? customerPrices.find(cp => cp.quantity >= count)
    : null;
  if (correctCustomerPrice) {
    totalPrice = prop(correctCustomerPrice, 'unitprice') * +count;
  }

  const priceWithUnpacking = correctUnpackingCost + +totalPrice;
  let minimalPrice = isSpojMat
    ? isLoggedIn
      ? +priceWithUnpacking > 0.75
        ? priceWithUnpacking
        : '0.75'
      : +priceWithUnpacking > 0.75
      ? priceWithUnpacking
      : '0.92'
    : totalPrice;

  if (isSpojMatOrPreDrev(product) && onStock === 0) {
    minimalPrice = 0;
  }
  const correctPerUnitPrice = !isFocused ? round(minimalPrice / +count, 2) : '';
  const handleInputFocus = () => {
    setIsFocused(true);
  };

  const handleInputBlur = () => {
    setIsFocused(false);
  };

  return (
    <>
      <StyledTableTd align="right">
        {!isRequest && minimalPrice > 0 && (
          <Price>{`${
            correctPerUnitPrice
              ? `${formatPriceToString(correctPerUnitPrice, currency)}`
              : ''
          }`}</Price>
        )}
      </StyledTableTd>
      <StyledTableTd>
        <CountWrapper>
          <CountSetter
            onChange={handleCountChange}
            unit={unit}
            count={count}
            step={step}
            handleInputFocus={handleInputFocus}
            handleInputBlur={handleInputBlur}
            defaultPackageSize={defaultPackageSize}
            wholePackagesOnly={wholePackagesOnly}
            onStock={onStock}
            noHandlingFee={noHandlingFee}
          />
        </CountWrapper>
      </StyledTableTd>
      <StyledTableTd>
        <Package>
          {getPackagesString(
            defaultPackageSize ? defaultPackageSize : productPackages,
            unit,
          )}
        </Package>
      </StyledTableTd>
      <StyledTableTd>
        {!isRequest && minimalPrice > 0 && (
          <Package>{formatPriceToString(minimalPrice, currency)}</Package>
        )}
      </StyledTableTd>
    </>
  );
}

const StyledTableTd = styled(TableTd)`
  padding: ${rem(16)} 0;
  margin-left: ${rem(8)};
`;

const CountWrapper = styled(FlexRowCenterHorizontal)`
  margin-left: ${rem(28)};
`;

const Price = styled(TextP)`
  font-size: ${rem(14)};
  line-height: ${rem(22)};
  margin-left: ${rem(8)};
`;

const Package = styled(Price)`
  margin-left: 0;
`;

const WithTheme: any = withTheme(ModalItemsTabRow);
export { WithTheme as ModalItemsTabRow };
